import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC } from 'react';
import InputControl from '@/components/form/input-control';
import { Box, Stack } from '@mui/material';
import { TelemetryModel } from '@/lib/models/telemetry/telemetry.model';
import { DatadogTelemetryModel } from '@/lib/models/telemetry/datadog-telemetry.model';
import Text from '@/components/text';
import Icon from '@/components/icon';
import DrawerFormSection from '@/components/form/drawer-section';

interface Props {
  telemetry: DatadogTelemetryModel;
  formHandle: FormHandle<TelemetryModel>;
  isNew: boolean;
}

const DatadogTelemetry: FC<Props> = ({ formHandle, isNew }) => {
  return (
    <Box>
      <InputControl name="config.site" formHandle={formHandle} type="datadog-site-select" />

      <InputControl
        name="config.apiKey"
        label="API Key"
        formHandle={formHandle}
        updateOnly={!isNew}
        required={isNew}
      />

      <DrawerFormSection label="Metadata" />

      <InputControl name="config.ddsource" label="Source" formHandle={formHandle} required />

      <InputControl name="config.ddtags" label="Tags" formHandle={formHandle} />

      <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={0.5}>
        <Icon size="small" name="info-circle" color="grey" />
        <Text size="small" color="grey">
          Separate tags with spaces
        </Text>
      </Stack>

      <InputControl name="config.service" label="Service" formHandle={formHandle} />

      <InputControl name="config.hostname" label="Hostname" formHandle={formHandle} />
    </Box>
  );
};

export default DatadogTelemetry;
